
<template>
  <div 
    :style="colorWidth" 
    class="cell-item"
    ref="cellBoxRef"
  >
        <span 
            class="cell-item-box"  
            ref="cellRef"  
            v-if="!isPreviewName"
            :style="{height: hasPreview ?'52px':'auto'}"
        >
            <slot/>
        </span>
        <template v-else>
            <div class="cell-item-preview" >
                <span v-if="previewPath.length<=1">{{previewPath || '-'}}</span>
                <!--   -->
                <img v-else-if="!isError" 
                    style="max-height: 50px;max-width: 100%;"  
                    v-popover="popoverRef" 
                    :src="previewPath" 
                    @error="resourcesError"
                />
                <img v-else  style="height: 50px;"   class="error-img" src="~@/assets/img/error.png"/>
                <!-- <el-image
                    
                    :src="previewPath"
                    
                    @error="resourcesError"
                   
                    fit="cover">
                    
                </el-image> -->
            </div>
        </template>
            <!-- :disabled="isError" -->
        <el-popover
            v-if="isPreviewName && previewPath.length>1"
            placement="left"
            trigger="hover"
            ref="popoverRef"
            @show="showPopover"
            @after-leave="hidePopover"
            :visible-arrow="false"
            :popper-class="isScroll?'hide-popover':''"
            :open-delay="300"
        >
            <div class="preview-popover" v-if="preview" >
                <div class="preview-box">
                    <template v-if="isImage">
                        <img 
                            v-if="!previewError"
                            class="resources" 
                            :src="data[column.field]" 
                            oncontextmenu="return false;"
                            @error="()=>previewError = true"
                        />
                        <img v-else class="resources" src="~@/assets/img/error.png"/>
                    </template>
                    <template v-else >
                        <video 
                            v-if="!previewError"
                            class="resources" 
                            controls 
                            controlslist="nodownload noremoteplayback noplaybackrate nofullscreen" 
                            disablepictureinpicture="true" 
                            disableremoteplayback="true" 
                            :src="data[column.field]" 
                            oncontextmenu="return false;" 
                            ref="videoRef"
                            @error="()=>previewError = true"
                        />
                        <img v-else class="resources" src="~@/assets/img/error.png"/>
                    </template>
                </div>
                <div class="preview-opt tac" >
                    <template v-if="hasDownload">
                        <el-button 
                            v-permission="['download_material_with_watermark']" 
                            icon="el-icon-download"
                            @click="()=>global.downloadMaterialWatermark(previewPath)"
                            :loading="loadingData.downloadLoading"
                        >
                            下载原素材-有水印
                        </el-button>
                        <el-button 
                            v-permission="['download_material_without_watermark']" 
                            icon="el-icon-download"
                            @click="()=>global.downloadMaterialNoWatermark(previewPath)"
                            :loading="loadingData.downloadLoading"
                        >
                            下载原素材-无水印
                        </el-button>
                    </template>
                    <el-button 
                        v-if="!previewError"
                        icon="el-icon-full-screen"
                        @click="()=>fullScreenPreview(data[column.field])"
                    >
                    <!-- fullScreenPreviewModal -->
                        全屏查看
                    </el-button>
                </div>
            </div>
        </el-popover>
  </div>
</template>

<script>
import { DIMENSION_PREVIEW_LIST, DIMENSION_NO_FILTER_LIST, DIMENSION_PREVIEW_NODOWN_LIST, MATERIAL_TYPE } from '../../constant'
import { on, off } from 'element-ui/src/utils/dom';
let POPOVER_REF = null;
import { fullScreenPreviewModal } from '../../modal'
export default {
    props: [ 'data', 'prop', 'column', 'hasPreview', 'isScroll', 'renderEnd', 'hasAddCondition' ],
    inject: [ 'setPopoverXY', 'colsePopover', 'global', 'loadingData' ],
    data() {
        return {
            isError: false,
            preview: false,
            previewError: false
        }
    },
    computed: {
        popoverRef() {
            // this.isError ? '' : 'popoverRef'
            return 'popoverRef'
        },
        colorWidth() {
            return {
                '--i': ((this.data[`${this.prop}_color_bar`] || 0) * 100) +'%'
            }
        },
        isPreviewName() {
            return DIMENSION_PREVIEW_LIST.includes(this.column.field);
        },
        previewPath() {
            return this.data[`${this.column.field}_thumbnail`] || '';
        },
       
        // 是否有下载按钮
        hasDownload() {
            return !DIMENSION_PREVIEW_NODOWN_LIST.includes(this.column.field)
        },
        isImage() {
            return this.data.m_material_type === MATERIAL_TYPE.image;
        },
    },
    methods: {
        fullScreenPreview(url) {
            fullScreenPreviewModal({
                props: {
                    url,
                    isImage: this.isImage
                }
            })
        },
        hidePopover() {
            // HTMLVideoElement
            const videoRef = this.$refs.videoRef;
            if (videoRef) {
                videoRef.pause()
            }
        },
        showPopover() {
            this.preview = true;
            const ref = this.$refs.popoverRef
			if (POPOVER_REF && ref !== POPOVER_REF) {
				POPOVER_REF.doClose();
			}
			POPOVER_REF = ref;
        },
        resourcesError() {
            this.isError = true;
        },
        handleMouseenter(e) {
            if (this.isScroll) {
                return;
            }
            this.setPopoverXY(e, this.column, this.data)
        },
        handleMouseLeave(e) {
            this.colsePopover(e, this.column, this.data)
            // this.setPopoverXY(false);
        }
    },
    mounted() {
        // iObserver
        // cell-popover
        if (!this.hasAddCondition) {
            return
        }
        this.$nextTick(()=> {
            const cellRef = this.$refs.cellRef;
            on(cellRef, 'mousemove', this.handleMouseenter);
            on(cellRef, 'mouseout', this.handleMouseLeave);
        })
    },
    destroyed() {
        const cellRef = this.$refs.cellRef;
        off(cellRef, 'mousemove', this.handleMouseEnter);
        off(cellRef, 'mouseout', this.handleMouseLeave);
    }
}
</script>
<style>
.hide-popover {
    display: none;
}
</style>
<style lang="scss" scoped>
.cell-item {
    // position: relative;
    height: 100%;
    display: inline;
    &-box {
        position: relative;
        z-index: 1;
        height: 100%;
    }
    &-preview {
        text-align: center;
        .error-img {
           max-width: 100%;
           max-height: 100%;
        }
    }
    &::before {
        content: '';
        position: absolute;
        top: 4px;
        left: 0;
        bottom: 4px;
        background: #c2e0ff;
        width: var(--i);
        z-index: 0;
        max-width: 96%;
    }
}
.preview-popover {
    width: 440px;
    display: flex;
    height: 300px;
    flex-direction: column;
    .preview-box {
        flex: 1;
        height: 0;
        background: #f3f3f3;
        text-align: center;
        min-height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        .resources {
            max-width: 100%;
            max-height: 100%;
        }
        // .full-screen {
        //     position: absolute;
        //     z-index: 4;
        //     top: 50%;
        //     left: 50%;
        //     transform: translate(-50%);
        //     font-size: 24px;
        //     color: #409EFF;
        //     font-weight: bolder;
        // }
    }
    .preview-opt {
        padding-top: 10px;
        
    }
}
</style>